import { fetchApi } from '@/config/axiosSetting';

import {
  getBodyVehicleInformationType,
  GetBodyVehicleInformationType,
} from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyVehicleInformation/getBodyVehicleInformation.type';

export const getBodyVehicleInformationFunction = ({
  id,
}: getBodyVehicleInformationType): Promise<GetBodyVehicleInformationType> => {
  return fetchApi.get(`/body/reports/${id}/vehicle_information/`);
};
